import { Dispatch } from 'react';

import { useDispatch } from 'react-redux';

import { AppDispatch } from '../store';

export const useToolkitDispatch: () => AppDispatch = useDispatch;

export const useAppDispatch: () => Dispatch<any> = useDispatch;
